import React, { useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { MAP_ELEMENT } from "../../../contexts/WorldMapContext/constants";
import { FactoryMarker } from "../../../contexts/WorldMapContext/Marker";
import { selectFactory } from "../../../util/store/factory/constants";
import { selectOneSetting, selectViewMode } from "../../../util/store/selectors";
import { IFactory } from "../../../util/varibles/interface";
import { VIEW_MODE } from '../../../util/varibles/permission';
import { DashboardSetting } from "../../../util/varibles/userSetting";
import { dashboardActions } from "../reducer";

interface IProps {
    ids: Set<string>
}

const Factories: React.FC<IProps> = ({ ids }) => {
    const isFactory = useSelector(selectOneSetting(DashboardSetting.FACTORIES));
    const source = useSelector(selectFactory.data) || [];
    const viewMode = useSelector(selectViewMode);
    const dispatch = useDispatch();

    const onClick = useCallback((data: IFactory) => {
        dispatch(dashboardActions.showInfo({ data, targetType: MAP_ELEMENT.FACTORY }));
    }, [dispatch])

    if (viewMode === VIEW_MODE.SITE)
        return null;

    return <>
        {source.map(item => <FactoryMarker
            key={item.id}
            data={item}
            show={isFactory && (ids.size === 0 || ids.has(item.id || ''))}
            onClick={() => onClick(item)}
        />)}
    </>;
};

export default Factories;
